export const CANALBANCARIOEXTERIOR = "@CANAL_BANCARIO_EXTERIOR";
export const LABELDOCUMENTOCOMPROVANTEREMESSA = "@LABEL_DOCUMENTO_COMPROVANTE_REMESSA";
export const AVISOANTIGOLPE = "@TEXTO_AVISOANTIGOLPE";
export const CLIENTEISTOKENATIVO = "@GET_ISTOKEN_ATIVO";
export const CLIENTESALOD = "@CLIENTE_SALDO"
export const CLIENTEDOCUMENTOS = "@CLIENTE_DOCUMENTOS";
export const CLIENTEENDERECOS = "@CLIENTE_ENDERECOS";
export const COMPOSICAOREMESSA = "@COMPOSICAO_REMESSA";
export const NOTIFICATION = "@NOTIFICATION";
export const HISTORICOSALDOCLIENTE = "@HISTORICO_SALDO_CLIENTE";
export const VITRINEREMESSA = "@VITRINE_REMESSA";
export const VITRINERECEBIMENTO = "@VITRINE_RECEBIMENTO";
export const VITRINEOURO = "@VITRINE_OURO";
export const VITRINETURISMO = "@VITRINE_TURISMO";
export const NATUREZAOPERACAO = "@NATUREZA_OPERACAO";
export const HORARIOFUNCIONAMENTO = "@HORARIO_FUNCIONAMENTO";
export const PEDIDOCOMPROVANTES = "@PEDIDO_COMPROVANTES";
export const TIPOCLIENTEDOCUMENTOS = "@CLIENTE_TIPO_DOCUMENTOS";
export const FORMAPAGEMENTOOPERACAO = "@OPERACAO_FORMAPAGAMENTO";
export const PAIS = "@PAIS";
export const PAISPAGADORRECEBEDOR = "@PAIS_PAGADORRECEBEDOR";
export const TIPOSPAGADORRECEBEDOR = "@TIPOS_PAGADORRECEBEDOR";
export const PAGADORRECEBEDORIDPAISIDCLIENTEIDTIPO = "@PAGADORRECEBEDOR_IDPAIS_IDCLIENTE_IDTIPO";
export const CARRINHOTEMPORARIO = "@CARRINHO_TEMPORARIO"
export const TIPOSPROPRIEDADEPAGADORRECEBEDORIDPAIS = "@TIPOS_PROPRIEDADE_PAGADORRECEBEDOR_IDPAIS";
export const MEUSPEDIDOSTURISMO = "@MEUSPEDIDOS_TURISMO";
export const MEUSPEDIDOSCOMERCIAL = "@MEUSPEDIDOS_COMERCIAL";
export const MEUSPEDIDOSCAMBIO = "@MEUSPEDIDOS_CAMBIO";
export const TIPOSMERCADO = "@TIPOS_MERCADO";
export const DETALHEPEDIDOCOMERCIAL = "@DETALHE_PEDIDO_COMERCIAL";
export const DETALHEPEDIDOTURISMO = "@DETALHE_PEDIDO_TURISMO";
export const DETALHEPEDIDOSEGUROVIAGEM = "@DETALHE_PEDIDO_SEGUROVIAGEM";
export const DETALHEPEDIDOCHIPINTER = "@DETALHE_PEDIDO_CHIP_INTER";
export const DETALHEPEDIDOOURO = "@DETALHE_PEDIDO_OURO";
export const PONTOSRETIRADA = "@PONTOS_RETIRADA";
export const REGIOESENTREGA = "@REGIOES_ENTREGA";
export const GETCARRINHOTEMPORARIO = "@GET_CARRINHO_TEMPORARIO";
export const GETCARRINHOTEMPORARIORECEBIMENTO = "@GET_CARRINHO_TEMPORARIO_RECEBIMENTO";
export const GETCUPOM = "@GET_CUPOM";
export const BANCOSNACIONAIS = "@GET_BANCOS_NACIONAIS";
export const PEDIDOCONCLUIDOPAGAMENTOESCOLHIDO = "@GET_FORMA_PAGAMENTO_PEDIDO_FINALIZADO";
export const LOJAFECHADA = "@LOJA_FECHADA";
export const DADOSBANCARIOS = "@DADOS_BANCARIOS";
export const GETALLITENSCARRINHO = "@GET_ALL_iTENS_CARRINHO";
export const GETITENSTURISMOFINALIZACAOPEDIDO = "@GET_ITENS_TURISMO_FINALIZACAO_PEDIDO";
export const GETVALORSEDEX = "@GET_VALOR_SEDEX";
export const GETALLVITRINESISHABILITADA = "@GET_VITRINES_HABILITADAS";
export const GETTERMORESPONSABILIDADE = "@GET_TERMO_RESPONSABILIDADE";
export const GETVALORESITEMSTURISMO = "@GET_VALORES_ITEM_TURISMO";
export const GETVALORESITEMSREMESSA = "@GET_VALORES_ITEM_REMESSA";
export const GETVALORESITEMSRECEBIMENTO = "@GET_VALORES_ITEM_RECEBIMENTO";
export const GETVALORESITEMSOURO = "@GET_VALORES_ITEM_OURO";
export const ORDEMPAGAMENTO = "@GET_ORDEM_PAGAMENTO";
export const ORDEMPAGAMENTOBYID = "@GET_ORDEM_OBYID";
export const GETITENSCARRINHOOURO = "@GET_ITENS_CARRINHO_OURO";
export const GETDADOSCORRETORA = '@GET_DADOS_CORRETORA';
export const GETPEDIDOCONCLUIDOSEGURO = '@GET-DADOS-PEDIDO-CONCLUIDO-SEGURO';
export const GETPEDIDOCONCLUIDO = '@GET_DADOS_PEDIDO_CONCLUIDO';
export const GETPENDENCIASCLIENTE = '@GET_PENDENCIAS_CLIENTE';
export const FINALIDADES = '@FINALIDADES';
export const SEOTAGS = '@SEO_TAGS';
export const GETVITRINECHIP = '@GET_VITRINE_CHIP';
export const GETCARRINHOCHIP = '@GET_CARRINHO_CHIP';
export const GETCARRINHO = "@GET_CARRINHO"
export const GETDISPOSITIVOSCOMPATIVEIS = '@GET_DISPOSITIVOS_COMPATIVEIS';
export const GETDADOSCLIENTE = '@GET_DADOS_CLIENTE'
export const TIPOSATIVIDADE = "@TIPOS_ATIVIDADE";
export const NACIONALIDADES = "@NACIONALIDADES";
export const GETCARTAOCLIENTE = "@GET_CARTAO_CLIENTE";
export const VITRINECRIPTO = "@VITRINECRIPTO";